<section
	*qeHideProd
	role="alert"
	aria-live="polite"
	class="environment-warning"
>
	<epi-icon
		use="error"
		color="custom:#ffffff"
		:size="20"
		class="environment-warning__icon"
	></epi-icon>
	
	<div class="environment-warning__message">
		IMPORTANT: QuoteEngine is running in the {{ environmentId }} environment!
		<p *ngIf="testName" class="kameleoon-message">
			Active A/B Test: {{ getActiveTest() }} -- Active Variation: {{ getActiveTestVariation() }}
		</p>
	</div>
</section>

<div class="app" [ngClass]="{'with-env-warning': !isProdEnvironment, 'with-route-buttons': showDevRoutes.value}">
	<section
		*qeHideProd
		class="dev-routes-wrapper"
	>
		<div class="dev-routes-wrapper__actions">
			<div class="dev-routes-wrapper__checkbox">
				<input
					[formControl]="showDevRoutes"
					type="checkbox"
					name="showDevRoutes"
					id="showDevRoutes"
					class="dev-routes-toggle"
				>
				<label for="showDevRoutes">Show Route Buttons</label>
			</div>
			<button (click)="resetSession()">Reset Session and restart</button>
		</div>
		<section
			class="dev-routes"
			*ngIf="showDevRoutes?.value"
		>
			<button [routerLink]="[ROUTES.BASE]">Route 1</button>
			<button [routerLink]="[ROUTES.SELECT_A_POLICY]">Route 2</button>
			<button [routerLink]="[ROUTES.CONTACT_INFORMATION]">Route 3</button>
			<button [routerLink]="[ROUTES.CONGRATULATIONS]">Route 4</button>
		</section>
	</section>
	<section class="app__header">
		<qe-header></qe-header>
		<qe-breadcrumbs [ngClass]="{'is--branded': (brandConfig$ | async)?.id?.toLowerCase() !== 'embrace'}">
			<qe-breadcrumbs-step [step]="1"></qe-breadcrumbs-step>
			<qe-breadcrumbs-step [step]="2"></qe-breadcrumbs-step>
			<qe-breadcrumbs-step [step]="3"></qe-breadcrumbs-step>
		</qe-breadcrumbs>
	</section>
	<main class="app__content">
		<router-outlet></router-outlet>
	</main>
	<section class="app__footer">
		<qe-footer></qe-footer>
	</section>
</div>
<epi-large-loader
	#epiLargeLoader
	class="app__loader m--large"
	[attr.loading-text]="(loadingText$ | async)"
></epi-large-loader>
